// @flow
export const dataKey: 'profile' = 'profile';
